import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import type { ViewComponent } from "@frui.ts/views";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import LicensePlateInput from "controls/licensePlateInput";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import type ChangeVehicleViewModel from "viewModels/callCenter/actions/changeVehicleViewModel";
import CountrySelect from "../../../common/countrySelect";
import { startOfEDAZDistribution } from "config";
import { czechTodayDate, disabledDaysRange } from "utils/dateUtils";
import Button from "@edaz/edazkit/Button";
import { translateGeneral } from "utils/localizations";
import { IconType } from "@edaz/edazkit/Icon";

const ChangeVehicleForm: ViewComponent<ChangeVehicleViewModel> = observer(({ vm }) => (
  <>
    <Form.Row>
      <FormGroup as={Col} md={6} target={vm.item} property="oldCountryId">
        <FormLabel>{vm.translateAttribute("oldCountryId")}</FormLabel>
        <CountrySelect vm={vm.countrySelectViewModel} />
      </FormGroup>
      <FormGroup as={Col} md={6} target={vm.item} property="oldLicensePlate">
        <FormLabel>{vm.translateAttribute("oldLicensePlate")}</FormLabel>
        <LicensePlateInput />
      </FormGroup>
      <FormGroup as={Col} md={6} target={vm.item} property="newCountryId">
        <FormLabel>{vm.translateAttribute("newCountryId")}</FormLabel>
        <CountrySelect vm={vm.countrySelectViewModel} />
      </FormGroup>
      <FormGroup as={Col} md={6} target={vm.item} property="newLicensePlate">
        <FormLabel>{vm.translateAttribute("newLicensePlate")}</FormLabel>
        <LicensePlateInput />
      </FormGroup>
      <FormGroup as={Col} md={6} target={vm.item} property="officialRecordId">
        <FormLabel>{vm.translateAttribute("officialRecordId")}</FormLabel>
        <AdvancedInput transformation={Transformation.UpperCased} />
      </FormGroup>
      <FormGroup as={Col} md={6} target={vm.item} property="submissionDate">
        <FormLabel>{vm.translateAttribute("submissionDate")}</FormLabel>
        <DatePickerBox
          fromMonth={startOfEDAZDistribution}
          toMonth={czechTodayDate()}
          disabledDays={disabledDaysRange(czechTodayDate(), startOfEDAZDistribution)}
        />
      </FormGroup>
    </Form.Row>
    <div className="d-flex justify-content-center reset-focus" style={{ padding: "1rem 0" }}>
      <Button type="reset" onClick={vm.requestClose} variant="light" style={{ minWidth: "13.5rem" }}>
        {translateGeneral("cancel")}
      </Button>
      <Button
        type="submit"
        iconLeft={IconType.Search}
        onClick={vm.onSubmit}
        style={{ minWidth: "13.5rem" }}
        disabled={vm.noChargesNoExemptionsWarning}>
        {translateGeneral("continue")}
      </Button>
    </div>
  </>
));

export default ChangeVehicleForm;
